module.exports = __webpack_public_path__ + "img/cloud-refresh.11cd7d42.svg";